import ElementHandler from "~/services/elementHandler";
import ModelMapping from "~/models/mapping/modelMapping";
import TrackedModel from "~/models/tracked/trackedModel";
import {IModelMapping, IOriginWrapper} from "~/interfaces/mappingInterfaces";

export default class ModelMappingHandler<T extends TrackedModel & IModelMapping = ModelMapping> extends ElementHandler<T> {
  /**
   * @param sourceClientId {String} the client_id of the
   * @return array of model mappings where the source_identifier is the provided sourceClientId
   */
  withSource(sourceClientId: string): T[] {
    const modelMappings = this.model[this.collectionKey]
    return Object.keys(modelMappings).reduce<T[]>((agg, key) => {
      if (modelMappings[key].source_identifier === sourceClientId) {
        agg.push(modelMappings[key])
      }
      return agg
    }, [])
  }

  destinationOptionsForSource(allOptions: IOriginWrapper[], source: IOriginWrapper): IOriginWrapper[] {
    const modelMappingsWithSource = this.withSource(source.rootIdentifier)
    return allOptions.filter(destination => {
      return !modelMappingsWithSource.find(modelMapping => {
        return destination.rootIdentifier === modelMapping.destination_identifier
      })
    })
  }
}